import { useRef } from 'react';
import classNames from 'classnames';
import { components } from 'react-select';
import { CSSTransition } from 'react-transition-group';

import {
  MenuProps,
  GroupBase,
} from '../../types';

import s from './MenuMobileBottom.sss';

const Component = components.Menu;

export function MenuMobileBottom<
Option,
IsMulti extends boolean = false,
Group extends GroupBase<Option> = GroupBase<Option>,
>(props: MenuProps<Option, IsMulti, Group>) {
  const ref = useRef(null);

  return (
    <CSSTransition
      in={true}
      appear={true}
      timeout={300}
      classNames={{
        appear: s.appear,
        appearActive: s.appearActive,
      }}
      nodeRef={ref}
    >
      <Component
        {...props}
        // @ts-ignore
        ref={ref}
        className={classNames(props.className, s.root)}
      >
        {props.children}
      </Component>
    </CSSTransition>
  );
}
